/*
 * HP右下のLINEボタンを、見に来た人の入り口ごとに「計測用の友だち追加リンク」へ切り替える(2026-11-04 まゆさん決定)
 *   インスタ経由(UTM・アクセス元・Instagramアプリ内ブラウザ) → 経路 instagram / insta / hp
 *   検索(Google・Yahoo!など)経由                              → 経路 ホームページ / hp / organic
 *   それ以外(直接・広告・メール・LINEなど)                      → 経路 ホームページ / hp / other
 * 数は、LINE公式アカウント管理画面の「分析 → 友だち → 追加経路」に出る。
 * 入り口は、その訪問(タブを閉じるまで)のあいだ覚えておく。ページを移っても変わらない。
 * 個人情報は使わない・送らない。GAには、押された数と入り口(line_src)だけ送る。
 */
(function () {
  var KEY = 'don_line_src';
  var URLS = {
    instagram: 'https://lin.ee/XQ3pcR8',   // instagram / insta / hp
    organic: 'https://lin.ee/SGvN8Cn',     // ホームページ / hp / organic
    other: 'https://lin.ee/VkQdBuC'        // ホームページ / hp / other
  };

  function classify() {
    var q = new URLSearchParams(location.search);
    var src = (q.get('utm_source') || '').toLowerCase();
    var med = (q.get('utm_medium') || '').toLowerCase();
    var host = '';
    try { host = new URL(document.referrer).hostname.toLowerCase(); } catch (e) {}
    var ua = navigator.userAgent || '';
    if (/instagram/.test(src) || src === 'ig' || /(^|\.)instagram\.com$/.test(host) || /Instagram/.test(ua)) return 'instagram';
    if (med === 'organic' || (!src && /(^|\.)(google|yahoo|bing|duckduckgo|ecosia|baidu|naver)\./.test(host + '.'))) return 'organic';
    return 'other';
  }

  function current() {
    var c = classify(), saved = null;
    try { saved = sessionStorage.getItem(KEY); } catch (e) {}
    // はっきりした入り口(インスタ・検索)は上書きする。「それ以外」は、まだ何も覚えていないときだけ
    if (c !== 'other' || !saved) {
      saved = c;
      try { sessionStorage.setItem(KEY, c); } catch (e) {}
    }
    return saved;
  }

  var kind = current();

  function apply() {
    var a = document.querySelector('a[href*="access.line.me/oauth2"][href*="state=hp"], a[class*="ai-line-float-button__link"]');
    if (!a || a.getAttribute('data-line-src')) return !!a;
    a.setAttribute('href', URLS[kind]);
    a.setAttribute('data-line-src', kind);
    a.addEventListener('click', function () {
      try { if (window.gtag) window.gtag('event', 'line_button_click', { line_src: kind }); } catch (e) {}
    });
    return true;
  }

  function start() {
    if (apply()) return;
    var n = 0, t = setInterval(function () { if (apply() || ++n > 40) clearInterval(t); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
